// Nueboo Size Helper - Minified
(function(w){
  // Band|Cup -> Nueboo Size (required for dropdown logic)
  w.sizeMap = {
    '28|A':'A','30|A':'A','32|A':'A','34|A':'A',
    '28|B':'A','30|B':'A','32|B':'A',
    '28|C':'A','30|C':'A','28|D':'A',
    '36|A':'B','34|B':'B','32|C':'B','30|D':'B','28|DD':'B',
    '36|B':'C','34|C':'C','32|D':'C','30|DD':'C','28|DDD/F':'C',
    '40|A':'D','38|B':'D','36|C':'D','34|D':'D','32|DD':'D','28|G':'D'
  };

  // Nueboo Size -> fits list
  var f = {
    A:'28A,30A,32A,34A,28B,30B,32B,28C,30C,28D',
    B:'36A,34B,32C,30D,28DD',
    C:'36B,34C,32D,30DD,28DDD/F',
    D:'40A,38B,36C,34D,32DD,28G'
  };
  w.fitsMap = f;

  w.getSizeFits = function(s) {
    return f[s] ? f[s].replace(/,/g, ', ') : '';
  };

  w.getSizeFitsHTML = function(s) {
    var t = w.getSizeFits(s);
    return t ? '<span style="display: flex; gap: .2rem;"><strong>Size ' + s + ' Fits: </strong>' + t : '</span>';
  };

  w.updateSizeResult = function(s, id) {
    var el = document.getElementById(id);
    if (el) {
      var h = w.getSizeFitsHTML(s);
      el.className = h ? el.className.replace(/\bhidden\b/, '') : el.className + ' hidden';
      el.innerHTML = h;
    }
  };
})(window);